import { render, staticRenderFns } from "./LeadsBackupView.vue?vue&type=template&id=1cd3f91a&scoped=true&"
import script from "./LeadsBackupView.vue?vue&type=script&lang=js&"
export * from "./LeadsBackupView.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1cd3f91a",
  null
  
)

export default component.exports